import React, {useContext, useEffect} from 'react';
import {ContextOperacion, ContextOperacionType} from "../../RefactorLayout";
import {useOperacionControlOperativo} from "./hooks/useOperacionControlOperativo";
import {EntityWithIdFields, QueryStatus} from "../../../../types";
import {useLoader} from "../../../../hooks/useLoader";
import {Alert, Grid} from "@mui/material";
import {FormOperacionControlOperativo, schemaFormOperacionControlOperativo} from "./types/types";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import SeccionControlOperativoDatosOperacion from "./components/SeccionControlOperativoDatosOperacion";
import SeccionControlOperativoDetalle from "./components/SeccionControlOperativoDetalle";
import {SeccionFirmas} from "../../components/SeccionFirmas";
import {OperacionControlOperativoViewDTO} from "./types/dto";
import {SistemaTipo} from "../../../../types/enum/enum";
import CardActions from "../../components/CardActions";
import {FilePutFields} from "../../api/file-fields";

interface SistemaControlOperativoContentProps {
  operacion: OperacionControlOperativoViewDTO
}

const SistemaControlOperativoContent = ({operacion}: SistemaControlOperativoContentProps) => {
  const {setSavePromise, permisoTipo} = useContext<ContextOperacionType>(ContextOperacion);

  const formMethods = useForm<FormOperacionControlOperativo>({
    resolver: zodResolver(schemaFormOperacionControlOperativo),
    values: {...operacion, [FilePutFields.File]: []}
  });

  const {showLoader, hideLoader} = useLoader();


  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <CardActions
            title={'Datos Operación'}
            colapsable
          >
            <SeccionControlOperativoDatosOperacion
              formMethods={formMethods}
              readOnly={!operacion.permiteEditarOperacion}
              operacion={operacion}
              codSistemaPrincipal={operacion.codPais}
            />
          </CardActions>
        </Grid>

        <Grid item xs={12}>
          <CardActions
            title={'Detalle'}
            colapsable
          >
            <SeccionControlOperativoDetalle
              codPais={operacion.codPais}
              operacionId={operacion.id}
            />
          </CardActions>
        </Grid>

        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.ControlOperativo}
            idOperacion={operacion[EntityWithIdFields.Id]}
          />
        </Grid>
      </Grid>
    </>
  );
}

function SistemaControlOperativo() {
  const {idOperacion} = useContext<ContextOperacionType>(ContextOperacion);

  const {status, operacion} = useOperacionControlOperativo(idOperacion);

  const {showLoader, hideLoader} = useLoader();

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader();
    } else {
      hideLoader();
    }
  }, [status]);

  if (!operacion) {
    return (
      <></>
    );
  }

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    );
  }

  return (
    <SistemaControlOperativoContent
      operacion={operacion}
    />
  );
}

export default SistemaControlOperativo;